import { IPromotionItemModel } from "../models";

export function getOrderTotal(
    promotionProducts: IPromotionItemModel[]
): number {
    if (!promotionProducts || promotionProducts.length <= 0) {
        return 0;
    }

    let total = 0;

    for (let i = 0; i < promotionProducts.length; i++) {
        let shipping = 0;

        if (promotionProducts[i].shippingPrice) {
            shipping = promotionProducts[i].shippingPrice || 0;
        }

        total += (promotionProducts[i].price || 0) + shipping;
    }

    return total;
}
